import { useTranslation } from 'next-i18next';
import { VFC } from 'react';

import { Creator, DraftToken } from '@/apis/aniftyBackend/users/interface';
import DraftCreationCard from '@/components/DraftCreationCard';
import routes from '@/config/routes';
import getImgixURL from '@/utils/getImgixURL';
import getThumbnailURL from '@/utils/getThumbnailURL';

import styles from './UserItemsSection.module.scss';

type Props = {
  user: Creator;
  draftToken: DraftToken;
};

const UsersDraftItem: VFC<Props> = ({ user, draftToken }: Props) => {
  const { i18n } = useTranslation();

  const draftTokenName =
    draftToken.nameJa && i18n.language === 'ja'
      ? draftToken.nameJa
      : draftToken.name;
  const creatorName =
    user.creatorProfile.nameJA && i18n.language === 'ja'
      ? user.creatorProfile.nameJA
      : user.creatorProfile.nameEN;

  const creatorImage = !user.profilePicUrl
    ? '/images/user-profile-page/default-profile-picture.png'
    : getImgixURL(user.profilePicUrl);

  return (
    <div className={styles.usersItem}>
      <DraftCreationCard
        link={routes.creationDetail(draftToken.creationID.toString())}
        creationImageUrl={draftToken.imageUrl}
        thumbnailUrl={getThumbnailURL(draftToken.imageUrl, {
          width: draftToken.width,
          height: draftToken.height,
          cropStartX: draftToken.cropStartX,
          cropStartY: draftToken.cropStartY,
          cropSize: draftToken.cropSize,
        })}
        creationName={draftTokenName}
        creatorName={creatorName}
        creatorProfileImageUrl={creatorImage}
      />
    </div>
  );
};

export default UsersDraftItem;
